import { STATUS_ERROR_INTERNAL, STATUS_FAILURE_PCMAIN_DUPLICATE, STATUS_FAILURE_PCMAIN_NOTREGISTER } from '@/common/constants';
import storage from '@/common/storage';
import { notifyError, notifyOfficeLogin } from './vp-notify';
import store from '@/top/store';
import { router } from '@riotjs/route';
import { ajaxPost, errorHandler } from './ajax';
import { pcCheckErrorHandler } from './pc/pc.action';

const pcMainCheck = async (officeId, apiKey, hwKey, force) => {
  try {
    await ajaxPost('/vpmain', {
      method: 'check',
      officeId,
      apiKey,
      hwKey,
      force: !!force
    });
    return true;
  } catch (e) {
    if (e?.status === STATUS_FAILURE_PCMAIN_NOTREGISTER) {
      router.push(`pc/register?officeId=${officeId}&apiKey=${apiKey}`);
      return false;
    } else if (e?.status === STATUS_FAILURE_PCMAIN_DUPLICATE) {
      if (await window.openConfirm('他のメインPCがすでに起動されています。他のメインPCを終了しますか？')) {
        await pcMainCheck(officeId, apiKey, hwKey, true);
        return true;
      } else {
        return false;
      }
    }
    throw e;
  }
};

const vp = {
  async startMain({ hwKey, setting }) {
    try {
      store.dispatch({ type: '@@vp/START_MAIN' });
      const officeId = storage.getOfficeId();
      const apiKey = storage.getApiKey();
      storage.setMode('main');
      storage.setHwKey(hwKey);
      storage.setVpSetting(setting);
      if (officeId && apiKey) {
        const result = await pcMainCheck(officeId, apiKey, hwKey, false);
        if (!result) {
          router.push('pc/check');
          return;
        }
        notifyOfficeLogin(officeId, apiKey);
        const path = `login/staff?officeId=${officeId}&apiKey=${apiKey}`;
        if (location.hash == `#${path}`) {
          location.reload();
        } else {
          router.push(`login/staff?officeId=${officeId}&apiKey=${apiKey}`);
        }
      } else {
        router.push('pc/check');
      }
    } catch (e) {
      store.dispatch(pcCheckErrorHandler(e));
      notifyError();
      const message = e?.message ?? '';
      if (e?.status === STATUS_ERROR_INTERNAL
        || message === 'Network Error'
        || message.includes('Failed to fetch')) {
        store.dispatch({ type: '@@vp/PC_CHECK_ERROR' });
      }
    }
  },

  startSub({ officeId, apiKey, setting }) {
    try {
      store.dispatch({ type: '@@vp/START_SUB' });
      storage.setMode('sub');
      storage.setVpSetting(setting);
      router.push(`login/staff?officeId=${officeId}&apiKey=${apiKey}`);
    } catch (e) {
      store.dispatch(errorHandler(e));
      notifyError();
    }
  },

  startNoVp({ officeId, apiKey, setting }) {
    try {
      store.dispatch({ type: '@@vp/START_NO_VP' });
      storage.setMode('noVp');
      storage.setVpSetting(setting);
      const _officeId = officeId || storage.getOfficeId();
      const _apiKey = apiKey || storage.getApiKey();
      if (_officeId && _apiKey) {
        location.href = `${location.origin}/top/#login/staff?officeId=${_officeId}&apiKey=${_apiKey}`;
      } else {
        router.push('pc/check');
      }
    } catch (e) {
      store.dispatch(errorHandler(e));
      notifyError();
    }
  },
  exit() { },
  callCreate() { },
  callUpdateTake() { },
  callGet() { },
  settingApply() { },
  settingSave() { },
  settingLoad() { },
  viewClear() { },
  viewCall() { },
  callApplyTake() { },
  viewAlarm() { },
  respLineMessage() { },
};

export default (payload) => {
  if (payload.method in vp) {
    vp[payload.method](payload);
  }
};
